import { render, staticRenderFns } from "./CinemaTesting.vue?vue&type=template&id=130bc53a&scoped=true&"
import script from "./CinemaTesting.vue?vue&type=script&lang=js&"
export * from "./CinemaTesting.vue?vue&type=script&lang=js&"
import style0 from "./CinemaTesting.vue?vue&type=style&index=0&id=130bc53a&scoped=true&lang=css&"
import style1 from "./CinemaTesting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130bc53a",
  null
  
)

export default component.exports